export default "__VITE_ASSET__BKjMrxGI__"